import './Polyfills.js';
import Animations from '../library/Animations';
import header from './Header';
//import cookieconsent from './Cookieconsent';
import mainnavigation from './Mainnavigation';
import mobilemainnavigation from './Mobilemainnavigation';
import mobilelangnavigation from './Mobilelangnavigation';
import mainteaser from './Mainteaser';
import propertysearch from './Propertysearch';
import propertytiles from './Propertytiles';
import quotes from './Quotes';
import mobilefooter from './Mobilefooter';
import scrollelements from './Scrollelements';
import propertydata from './Propertydata';
import gallery from './Gallery';
import propertygallery from './Propertygallery';
import propertygmap from './Propertygmap';
import propertyrequestform from './Propertyrequestform';
import bookmark from './Bookmark';
import customselect from './Customselect';
import fakeselect from './Fakeselect';
import location from './Location';
import propertysearchbar from './Propertysearchbar';

window.initMap = propertygmap;

// Preloader done
window.addEventListener('preloader-done', () => {
	init();
});


// Scroll
window.addEventListener('scroll', () => {
	header();
	propertysearchbar();
});


// Resize
window.addEventListener('resize', () => {
	let animations  = new Animations('.animation', 'animated');
	header();
	mainnavigation();
	mobilemainnavigation();
	mainteaser();
	mobilefooter();
	scrollelements('.footer');
	propertysearch();
	propertysearchbar();
	propertytiles();
	propertydata();
});


// Initial function calls
function init() {
	let animations  = new Animations('.animation', 'animated');

	mobilefooter();
	header();
	//cookieconsent();
	mainnavigation();
	mobilemainnavigation();
	mobilelangnavigation();
	mainteaser();
	propertysearch();
	propertysearchbar();
	propertytiles();
	quotes();
	scrollelements();
	propertydata();
	gallery();
	propertygallery();
	propertygmap();
	propertyrequestform();
	bookmark();
	customselect();
	fakeselect();
	location();
}



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Main.js